import { dcElement } from './dcElement.model';
import { dcTag } from './dcTag.model';
import { dcAttribute } from './dcattribute.model';

export class FileSaveInfo {
  tagInfo: dcTag;
  categoryName: string;
  attributeInfo: dcAttribute;
  activityElement?: dcElement;
}
